/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Listingcreated1Inputs */

const en_listingcreated1 = /** @type {(inputs: Listingcreated1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listing created!`)
};

const de_listingcreated1 = /** @type {(inputs: Listingcreated1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ort erstellt!`)
};

/**
* | output |
* | --- |
* | "Listing created!" |
*
* @param {Listingcreated1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const listingcreated1 = /** @type {((inputs?: Listingcreated1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Listingcreated1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_listingcreated1(inputs)
	return de_listingcreated1(inputs)
});
export { listingcreated1 as "listingCreated" }